
export { default as document } from "./main2.js"